/**
 * Checks if a single value is non-empty (not "", null, or undefined).
 */
function isNonEmptyValue(value: unknown): boolean {
  return value !== "" && value !== null && value !== undefined;
}

/**
 * Checks if a filter value has actual content (not empty, null, or undefined).
 * Handles both single values and arrays (for multi-select filters).
 *
 * @param value - The filter value to check (string, boolean, array, etc.)
 * @returns true if the value has actual content
 */
export function hasActualFilterValue(value: unknown): boolean {
  if (value === null || value === undefined) return false;

  if (Array.isArray(value)) {
    return value.some(isNonEmptyValue);
  }

  return value !== "";
}

/**
 * Extracts non-empty values from an array filter value.
 * Returns the original array filtered to only include non-empty values.
 *
 * @param value - The filter value array
 * @returns Array with only non-empty values
 */
export function getNonEmptyFilterValues(value: unknown[]): unknown[] {
  return value.filter(isNonEmptyValue);
}

/**
 * Extracts non-empty values from a filter value as a display string.
 * Useful for displaying filter values in chips.
 *
 * @param value - The filter value (string, array, etc.)
 * @returns The non-empty values as a string (joined by ", " for arrays)
 */
export function getFilterDisplayValue(value: unknown): string {
  if (value === null || value === undefined) return "";

  if (Array.isArray(value)) {
    return getNonEmptyFilterValues(value).join(", ");
  }

  return String(value);
}
